module.exports = __webpack_public_path__ + "img/Anniversary.f6ffc5fe.png";